import { z } from 'zod'

import { InvoiceStatus } from './domain/invoice'
import { InvoiceStatusEnum } from './domain/invoiceStatus'
import { DateFilterEnum } from '../../utils/dateFilters'

export const billingFilterSchema = z.object({
  from: z
    .number()
    .nullish()
    .transform((data) => data ?? undefined)
    .catch(0),
  size: z
    .number()
    .nullish()
    .transform((data) => data ?? undefined)
    .catch(10),
  invoiceStatus: z
    .array(InvoiceStatusEnum)
    .nullish()
    .transform((data) => data ?? undefined)
    .catch([InvoiceStatus.OUTSTANDING]),
  search: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  creationDateFrom: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  creationDateTo: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  creationDate: DateFilterEnum.nullish().transform((data) => data ?? undefined),
})

export const billingSearchSchema = z.object({
  filter: billingFilterSchema.nullish().transform((data) => data ?? undefined),
})

export type BillingFilterType = z.infer<typeof billingFilterSchema>
